import outdatedBrowserRework from "outdated-browser-rework";
import trans from "./react/helpers/trans";

outdatedBrowserRework({
    browserSupport: {
        'Edge': 45,
        'IE': false,
        'WebKit': true,
        'Chrome WebView': true,
        'FBAN': true,
        'FBAV': true,
        'Instagram': true,
    },
    requireChromeOnAndroid: false,
    isUnknownBrowserOK: true, // Needs this to avoid displaying message on Facebook/Instagram internal browser - See https://github.com/mikemaccana/outdated-browser-rework/issues/57
    language: 'en',
    messages: {
        en: {
            outOfDate: trans('outdated_browser_message.title'),
            unsupported: trans('outdated_browser_message.title'),
            update: {
                web: trans('outdated_browser_message.message'),
                googlePlay: trans('outdated_browser_message.message'),
                appStore: trans('outdated_browser_message.message'),
            },
            url: '',
            callToAction: '',
            close: trans('outdated_browser_message.close'),
        },
    },
});
